import PcDatabaseContent from "~/components/database/detail/database-content/PcDatabaseContent";
import SpDatabaseContent from "~/components/database/detail/database-content/SpDatabaseContent";
import {
  Props,
  useTableContent,
} from "~/components/database/detail/database-content/lib";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";

const DatabaseContent = (props: Props) => {
  const isSpMode = useIsSpMode();
  const tableContent = useTableContent(props.form.id);
  const propsWithResponses = { ...props, responses: tableContent };

  return isSpMode ? (
    <SpDatabaseContent {...propsWithResponses} />
  ) : (
    <PcDatabaseContent {...propsWithResponses} />
  );
};

export default DatabaseContent;
